import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { Api } from '../../typings/api';
import { viewDriveItem, DriveItemOrigin } from '../DriveItemList/actions';
import { createNotification } from '../NotificationBar/actions';
import { DriveItemListDisplayType } from '../DriveItemList/constants';
import DriveItemRow from '../../components/DriveItem/Row';
import DriveItemBlock from '../../components/DriveItem/Block';
import Loader, { LoaderType, LoaderStepName } from '../../components/Loader';
import { DownloadManagerState } from '../DownloadManager/reducer';
import { OfflineManagerState } from '../OfflineManager/reducer';
import UserAgentUtils from '../../utils/userAgent';
import { DriveItemContainerVariants, DriveItemVariants } from './styles';
import DownloadManagerUtils from '../../utils/downloadManager';

interface DriveItemProps {
	key: number;
	driveItem: Api.DriveItem;
	resolutions: { [k: string]: Api.ResolutionGroup };
	displayType: DriveItemListDisplayType;
	galleryConfig: Api.Config;
	dispatch: Dispatch<StoreState>;
	downloadManager: DownloadManagerState;
	offlineManager: OfflineManagerState;
}

const DriveItem = (props: DriveItemProps) => {
	const { driveItem, resolutions, displayType, galleryConfig, downloadManager, offlineManager, dispatch } = props;
	const DriveItemContainer = DriveItemContainerVariants[displayType];
	const StyledDriveItem = DriveItemVariants[displayType];
	const isDownloading = DownloadManagerUtils.isItemDownloading(downloadManager, driveItem.id);
	const loaderStep = DownloadManagerUtils.getItemLoaderStep(downloadManager, driveItem.id);

	const handleClick = () => {
		const { downloadManager, driveItem, dispatch } = props;
		const isDownloaded = DownloadManagerUtils.isItemDownloaded(downloadManager, driveItem.id);
		const isOnline = UserAgentUtils.isOnline();

		if (!isDownloading) {
			if (!isOnline && !isDownloaded && (driveItem.type !== Api.DriveItemType.Directory && driveItem.type !== Api.DriveItemType.Image)) {
				dispatch(createNotification('info.offline_download_single_asset'));
				return;
			}
			dispatch(viewDriveItem(driveItem, DriveItemOrigin.List));
		}
	};

	return (
		<DriveItemContainer>
			<StyledDriveItem onClick={handleClick}>
				{isDownloading &&
					<Loader loaderStep={loaderStep ? loaderStep : { step: LoaderStepName.Downloading }} type={LoaderType.Overlay}/>
				}
				{displayType === DriveItemListDisplayType.Row ? (
					<DriveItemRow
						dispatch={dispatch}
						driveItem={driveItem}
						resolutions={resolutions}
						galleryConfig={galleryConfig}
						offlineManager={offlineManager}
					/>
				) : (
					<DriveItemBlock
						dispatch={dispatch}
						driveItem={driveItem}
						resolutions={resolutions}
						displayType={displayType}
						galleryConfig={galleryConfig}
						offlineManager={offlineManager}
					/>
				)}
			</StyledDriveItem>
		</DriveItemContainer>
	);
};

const mapStateToProps = (state: StoreState) => {
	const { downloadManager, offlineManager } = state;
	return { downloadManager, offlineManager };
};

export default connect(mapStateToProps)(DriveItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/index.tsx